import * as TP from '../types';

import { gql } from '@apollo/client';
import { KeyValueInfoFragmentDoc } from './keyValueInfo';
export type AddressBriefFragment = (
  { readonly __typename?: 'Address' }
  & Pick<TP.Address, 'id' | 'addressableId' | 'addressableType' | 'addressTypeId' | 'city' | 'country' | 'main' | 'postalCode' | 'state' | 'street1' | 'street2' | 'isVerified' | 'riskInfoSource' | 'thirdPartyId'>
  & { readonly addressType?: TP.Maybe<(
    { readonly __typename?: 'KeyValue' }
    & Pick<TP.KeyValue, 'active' | 'id' | 'metadataJson' | 'name'>
  )>, readonly geopoint: (
    { readonly __typename?: 'Geopoint' }
    & Pick<TP.Geopoint, 'lon' | 'lat'>
  ) }
);

export const AddressBriefFragmentDoc = gql`
    fragment AddressBrief on Address {
  id
  addressableId
  addressableType
  addressType {
    ...KeyValueInfo
  }
  addressTypeId
  city
  country
  main
  postalCode
  state
  street1
  street2
  geopoint {
    lon
    lat
  }
  isVerified
  riskInfoSource
  thirdPartyId
}
    ${KeyValueInfoFragmentDoc}`;